import { render, staticRenderFns } from "./ModalLive.vue?vue&type=template&id=17ecf527&"
import script from "./ModalLive.vue?vue&type=script&lang=js&"
export * from "./ModalLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports